module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.47-70.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.0-rc.47.md
// module id = 486
// module chunks = 370